import React, { useState } from "react";
import { maintainanceTypeSorting, createdCompletedSort, maintainanceStatus } from "../../../Constants/adminConstant";
import { logger } from "../../../Utils";
import ImageComponent from "../../Admin/ProfileDetail/ListUsableComponent/ImageComponent";
import DropDown from "../DropDown";
import ThreeDotsDropdown from "../ThreeDotsDropdown";

const log = logger('MaintainanceHeader');
const MaintainanceHeader = (props) => {
    const { data, component, durationFilter, filterRent, sortStatusLease, sort_by_status_lease } = props;
    log.info(component);
    const [status, setStatus] = useState(false);
    const showStatus = () => {
        setStatus(!status);
    }
    return (
        <>
            {component === "maintainance" &&
                <>
                    {(() => {
                        switch (data.header) {
                            case 'ADDRESS':
                                return (
                                    <>
                                        {data.header}
                                    </>
                                )
                            case 'TYPE':
                                return (
                                    <span className="d-flex justify-content-between">
                                        {data.header}
                                        <DropDown close={() => setStatus(false)} open={status} position={"right"} enableTopArrow={false} style={{ width: "208px", top: "20px" }}
                                            content={
                                                <div className="row checkbox-left check-status">
                                                    {maintainanceTypeSorting.map((data, i) => {
                                                        return <div className="col-12" key={i}>
                                                            <div className="form-group">
                                                                <div className="custom-control custom-checkbox large">
                                                                    <input type="checkbox" className="custom-control-input" id={"customCheck" + data.value}
                                                                        name={data.value}
                                                                        checked={props.maintainanceType.includes(data.value)} onChange={props.sortByMaintainanceType}
                                                                    />
                                                                    <label className="custom-control-label capitalize pl-3 pt-1" htmlFor={"customCheck" + data.value}>{data.display}</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    })}
                                                </div>
                                            }
                                        >
                                            <div onClick={showStatus}><ImageComponent /></div>
                                        </DropDown>

                                    </span>
                                )
                            case 'CREATED':
                                return (
                                    <>
                                        {data.header}
                                        <ThreeDotsDropdown
                                            extraClass="display-inline"
                                            icon={<ImageComponent />}
                                            actionsButton={
                                                <>
                                                    {createdCompletedSort.map((data, i) => {
                                                        return <span className="dropdown-item sort-option cursorPointer" key={"created" + i} onClick={() => props.sortCreated(data.value)}>{data.display}</span>
                                                    })}
                                                </>
                                            }
                                        />
                                    </>
                                )
                            case 'COMPLETED ON':
                                return (
                                    <>
                                        {data.header}
                                        <ThreeDotsDropdown
                                            extraClass="display-inline"
                                            icon={<ImageComponent />}
                                            actionsButton={
                                                <>
                                                    {createdCompletedSort.map((data, i) => {
                                                        return <span className="dropdown-item sort-option cursorPointer" key={"completed" + i} onClick={() => props.sortCreatedOn(data.value)}>{data.display}</span>
                                                    })}
                                                </>
                                            }
                                        />
                                    </>
                                )
                            case 'STATUS':
                                return (
                                    <>
                                        {data.header}
                                        <ThreeDotsDropdown
                                            extraClass="display-inline"
                                            icon={<ImageComponent />}
                                            actionsButton={
                                                <>
                                                    {maintainanceStatus.map((data, i) => {
                                                        return <span className="dropdown-item sort-option cursorPointer" key={"main-status" + i} onClick={() => props.sortMaintainanceStatus(data.value)}>{data.display}</span>
                                                    })}
                                                </>
                                            }
                                        />
                                    </>
                                )
                            default:
                                return null
                        }
                    })()} </>}
        </>
    );
}
export default MaintainanceHeader;